<template>
  <div class="page">
    <section id="slideshow" class="slideshow">
      <video v-if="image.src.endsWith('.mp4')" :src="image.src"></video>
      <img v-else :src="image.src" :alt="image.alt" />
      <div class="info-text">
        <h1 class="title masterplan">{{ title }}</h1>
      </div>
    </section>
    <section id="page-menu" v-if="pageMenuItems.length > 0">
      <div class="container">
        <div class="menu">
          <div class="menu-item" v-for="item in pageMenuItems" :key="item.key">
            <router-link :to="item.url" :class="item.classes">
              {{ item.title }}
            </router-link>
            <span
              class="page-menu-divider"
              v-if="
                item.title !== pageMenuItems[pageMenuItems.length - 1].title
              "
              >|</span
            >
          </div>
        </div>
      </div>
    </section>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "page",
  props: {
    title: {
      type: String,
      default: "",
    },
    image: {
      type: Object,
      default: () => {
        return {
          src: "/assets/img/team/Teamfoto_m.jpg",
          alt: "employees",
        };
      },
    },
    pageMenuItems: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
};
</script>

<style scoped lang="less">
.page {
  margin-top: -145px;

  &.complaint {
    #page-menu {
      background: linear-gradient(#00a199ff, #00a19988);
      a:hover {
        color: #ffffff;
      }
    }
  }

  .slideshow {
    display: flex;
    max-width: 100%;
    height: 50vh;
    justify-content: center;
    text-align: center;

    img,
    video {
      object-fit: cover;
      object-position: center 20%;
      z-index: -1;
      min-width: 100%;
      filter: brightness(33%);
    }

    .info-text {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      height: calc(50vh);
      color: #ffffff;
      position: absolute;
      max-width: 100%;
      text-align: center;

      a {
        text-decoration: none;
        font-family: MasterPlan;
      }

      h1 {
        font-size: 100px;
        font-weight: lighter;
        transition-duration: 0.7s;
        color: #ffffff;
      }
    }
  }

  section {
    text-align: left;
    line-height: 1.8em;
    font-size: 100%;
    &#page-menu {
      .container {
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 10px;
        border-bottom: 1px solid #4e4d4d;
        .menu {
          display: flex;
          justify-content: center;
          flex-wrap: wrap;
          align-items: center;
          max-width: 100%;
          .menu-item {
            a {
              font-weight: bold;
              color: #4e4d4d;
              text-decoration: none;
              padding: 5px;
              &:hover {
                color: white;
              }
            }
          }
        }
      }
    }
  }
}

@media screen and (max-width: 768px) {
  .page {
    .slideshow {
      .info-text {
        h1 {
          font-size: 50px;
        }
      }
    }
    &#page-menu {
      .container {
        .menu {
          flex-direction: column;
          .menu-item {
            a {
              padding: 10px;
            }
            .page-menu-divider {
              display: none;
            }
          }
        }
      }
    }
  }
}
</style>
